window.PXUTheme = window.PXUTheme || {}

// Sticky header + optional Klaviyo trigger. Menu open/close lives in HeaderMenu.js.
window.PXUTheme.jsHeader = {
  init($section) {
    this.stickyInited = false

    this.element = document.querySelector('#header')
    this.container = $section[0]

    this.setupScrollListener()

    if (this.klaviyo_form_id) {
      this.handleKlaviyoForm()
      this.documentDelegate = new domDelegate.Delegate(document.documentElement)

      this.documentDelegate.on(
        'click',
        '[data-mobile-form-trigger]',
        this.openKlaviyoPopup.bind(this)
      )

      window.addEventListener('klaviyoForms', (event) => {
        if (
          event.detail.formId === this.klaviyo_form_id &&
          event.detail.type === 'close'
        ) {
          this.checkCookies()
        }
      })
      this.checkCookies()
    }
  },

  setupScrollListener() {
    let currentScroll = window.scrollY
    let hidden = null

    const headerHeight = () => (this.element && this.element.offsetHeight) || 110

    const followOffset = () => {
      if (!this.element) return
      const bottom = Math.round(this.element.getBoundingClientRect().bottom)
      document.documentElement.style.setProperty(
        '--header-offset',
        `${Math.max(0, bottom)}px`
      )
    }

    const applyHidden = (next) => {
      if (!this.element || next === hidden) return
      hidden = next
      this.element.style.transform = ''
      this.element.classList.toggle('scrolled', currentScroll > 0 || hidden)
      this.element.classList.toggle('show', !hidden)

      const until = Date.now() + 280
      const tick = () => {
        followOffset()
        if (Date.now() < until) requestAnimationFrame(tick)
      }
      tick()
    }

    const checkScroll = () => {
      const y = Math.max(0, window.scrollY)
      const threshold = headerHeight()
      const goingDown = y > currentScroll
      currentScroll = y

      if (y > 0) this.element.classList.add('scrolled')
      else if (!hidden) this.element.classList.remove('scrolled')

      if (goingDown && y >= threshold) applyHidden(true)
      else applyHidden(false)
    }

    applyHidden(currentScroll >= headerHeight())
    document.addEventListener('scroll', checkScroll, { passive: true })
  },

  handleKlaviyoForm() {
    const klaviyoOnsiteData = JSON.parse(localStorage.getItem('klaviyoOnsite'))
    const klaviyoFormID = this.klaviyo_form_id

    if (!klaviyoFormID) return

    if (
      klaviyoOnsiteData?.viewedForms?.modal?.disabledForms?.[klaviyoFormID]
        ?.successActionTypes
    ) {
      return
    }
  },

  openKlaviyoPopup() {
    window._klOnsite = window._klOnsite || []
    window._klOnsite.push(['openForm', this.klaviyo_form_id])
  },

  checkCookies() {
    const klaviyoOnsiteData = JSON.parse(localStorage.getItem('klaviyoOnsite'))
    const klaviyoFormID = this.klaviyo_form_id

    if (
      klaviyoOnsiteData?.viewedForms?.modal?.disabledForms?.[klaviyoFormID]
        ?.successActionTypes
    ) {
      // Previously cleared a RedDot on the legacy mobile burger.
    }
  }
}
